<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto" v-loading="loading" element-loading-text="加载中，请耐心等待。">
      <el-row style="height: 100%">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <div style="height: 50px;">
            <el-button type="primary" plain icon="el-icon-plus" @click="addProject()">新建项目</el-button>&nbsp;
            <el-input
              prefix-icon="el-icon-search"
              placeholder="输入姓名搜索"
              v-model="searchKeyword"
              style="width: 350px"
              clearable
            >
            </el-input>
          </div>
          <div style="max-height: calc(100% - 100px);overflow-y: auto;margin-right: 20px">
            <el-table
              :data="tbdata"
              border
              style="width: 100%"
              highlight-current-row
              ref="singleTable">
              <el-table-column
                type="index"
                label="序号"
                width="100"
              align="center">
              </el-table-column>
              <el-table-column
                prop="projectname"
                label="项目名称"
                min-width="150"
                align="center">
              </el-table-column>
              <el-table-column
                label="所属组织"
                min-width="130"
                align="center">
                <template slot-scope="scope">
                  <span>{{getOnOrg(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                min-width="160"
                align="center">
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="80">
                <template slot-scope="scope">
                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editProject(scope.row)"></i>
                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;height: 40px;text-align: center">
            <el-pagination v-fixZoom
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--created update-->
    <el-dialog
      :visible.sync="addEditShow"
      v-if="addEditShow"
      width="500px"
      :show-close="true"
      :close-on-click-modal="false"
      center
    class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>{{addEditTitle}}</span>
        </div>
        <div class="line-title"></div>
      </div>
      <add-edit-project :projectAddEdit="addEditRow" v-model="addEditShow"></add-edit-project>
    </el-dialog>
  </div>
</template>

<script>
import treeData from '../treeData/treeData.vue'
import addEditProject from './childComponents/addEditProject'
import {queryproject} from '../../api/serviceObject'
import {deleteproject} from '../../api/project'

export default {
  name: 'project',
  components: {treeData, addEditProject},
  data () {
    return {
      // 左边
      searchKeyword: '',
      isFirst: [],
      // 右边
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addEditTitle: '',
      addEditShow: false,
      addEditRow: {
        isAdd: true,
        orgTree: [],
        row: {}
      },
      orgid: ''
    }
  },
  created () {
    this.golobleObject.updateTablePro = this.getProjects
    this.orgid = this.$store.state.user.orgid
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    checkChange (obj) {
      if (obj.type === 'check') {
        this.oids = obj.orgids
        this.currentPage = 1
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.addEditRow.orgTree = obj.treeData
        this.getProjects()
      }
    },
    // 表格
    getProjects () {
      let data = {
        orgid: this.orgid
      }
      queryproject(data).then(res => {
        let isTime = res.data.projects.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.loading = false
        this.tableData = res.data.projects
        this.getEndTable()
      }).catch(() => {
        this.loading = false
      })
    },
    getEndTable () {
      this.showTable = []
      if (this.isFirst.length === 0) {
        this.showTable = this.tableData
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.isFirst.indexOf(this.tableData[i].orgid) > -1) {
            this.showTable.push(this.tableData[i])
          }
        }
      }
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.showTable
      const vm = this
      const search = data.filter((val) => {
        if (val.projectname.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    // 添加
    addProject () {
      this.addEditTitle = '新建项目'
      this.addEditShow = true
      this.addEditRow.isAdd = true
    },
    // 编辑
    editProject (row) {
      this.addEditTitle = '更新项目'
      this.addEditRow.row = row
      this.addEditRow.isAdd = false
      this.addEditShow = true
    },
    // 删除
    delDevice (row) {
      let name = row.projectname
      this.$confirm('此操作将永久删除该项目【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          ppids: [row.id]
        }
        deleteproject(data).then(res => {
          this.getProjects()
          this.$notify({
            title: '成功',
            message: '删除项目成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除项目失败'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      // this.getPersonPage()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.getPersonPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/project.vue